<template>
  <div class="design-preview" :class="{roundedCorners, imgBorder, portrait, compact}">
    <div>
      <img @load="imgLoad" :src="currentUrl" class="main">
      <button v-if="editButton" @click="$emit('edit')" class="btn edit-design"><i class="far fa-edit"/> Edit Design</button>
    </div>
    <div class="previews" v-if="previewUrls.length > 1">
      <img v-for="(url, index) in previewUrls" :src="url" :key="index" @click="currentIndex = index">
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors';

.design-preview {
  width: 504px;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  &.portrait {
    display:flex;
    width: 360px;
    flex-direction: row;
    align-items: center;
    height:504px;
    .previews {
        height: 300px;
    }
  }

  &.compact {
    width: auto;
    .previews {
      display: none;
    }
  }

  &.imgBorder img.main {
    border: 1px solid $gray-1;
  }
}

.edit-design {
  display: block;
  margin: 5px 0 5px auto;
  background: transparent;
  padding-right: 0;
  border-right: 0;
}

img {
  background: white;
}

.portrait img.main {
  width: 252px;
  max-width: 100%;
}

img.main {
  width: 504px;
  max-width: 100%;
}

.previews {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.portrait .previews {
  flex-direction: column;
  margin: 0 0 0 16px;
}

.previews img {
  border: 1px solid$gray-1;
  background: white;
  // Limit the size of the preview. If we specify using width, the
  // aspect ratio goes haywire. Height of 120px for landscape card
  // is about 300px wide. We specify a max, in terms of viewport width.
  // This prevents the previews from being too large on small devices.
  height: 120px;
  max-height: 20vw;
}

.roundedCorners img {
  border-radius: 5px;  // 1/8 inch = 9 pt = 4.5px
  &.main {
    border-radius: 18px;
  }
}

// When there are no previews, we can simply leave
// the box blank. This can happen if the server doesn't yet
// support previews, or the line was created a while ago, etc
.no_previews {
  width: 20px;
}
</style>

<script>
export default {
  props: ['previewUrls', 'rounded', 'editButton', 'imgBorder', 'compact'],
  data() {
    return {currentIndex: 0, portrait: false}
  },
  methods: {
    imgLoad(evt) {
      this.portrait = (evt.target.naturalWidth < evt.target.naturalHeight);
    }
  },
  computed: {
    currentUrl() {
      return this.previewUrls[this.currentIndex];
    },
    roundedCorners() {
      return this.rounded;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/DesignPreview.vue